import Modal from 'react-modal';
import { useState, useEffect} from 'react';
import { showMessageError, viewItem } from '../../../classes/functions';
import api from '../../../config.js';
import './conferred.css';
import Title from '../../../components/Title';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import { FaPen, FaTrash, FaCog, FaArrowLeft, FaArrowRight, FaSave } from 'react-icons/fa';
import ReactTooltip from "react-tooltip";
import { Link } from 'react-router-dom';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    width: '900px',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

export default function Conferred(){
  const [list, setList] = useState([]);
  const [listAll, setListAll] = useState([]);
  
  const [modalConferred, setModalConferred] = useState(false);

  const [listPesquisa, setListPesquisa] = useState('');

  const [editConference, setEditConference] = useState('vazio');

  const [listSearchProducts, setListSearchProducts] = useState([]);
  const [listSearchCliente, setListSearchCliente] = useState([]);
  const [listSearchEndereco, setListSearchEndereco] = useState([]);
  const [listStatus, setListStatus] = useState([]);
  const [listEnderecos, setListEnderecos] = useState([]);
  const [descricao_produto, setDescricaoProduto] = useState('');
  const [descricao_endereco, setDescricaoEndereco] = useState('');
  const [descricao_cliente, setDescricaoCliente] = useState('');

  const [qtdePage, setQtdePage] = useState(1000);
  const [limitPage, setLimitPage] = useState();
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState();

  const [pesquisa_endereco, setPesquisaEndereco] = useState('');
  const [pesquisa_cliente, setPesquisaCliente] = useState('');
  const [pesquisa_produto, setPesquisaProduto] = useState('');
  const [pesquisa_etiqueta_palete, setPesquisaEtiquetaPalete] = useState('');
  const [pesquisa_referencia_caixa, setPesquisaReferenciaCaixa] = useState('');
  const [pesquisa_status, setPesquisaStatus] = useState('');
  const [pesquisa_data, setPesquisaData] = useState('');
  const [pesquisa_usuario_conferiu, setPesquisaUsuarioConferiu] = useState('');
  const [pesquisa_usuario_enderecou, setPesquisaUsuarioEnderecou] = useState('');
  const [pesquisa_numero_documento, setPesquisaNumeroDocumento] = useState('');
  const [pesquisa_descricao_produto, setPesquisaDescricaoProduto] = useState('');

  const [edit_id, setId] = useState('');
  const [edit_data, setEditData] = useState('');
  const [edit_etiqueta_palete, setEditEtiquetaPalete] = useState('');
  const [edit_referencia_caixa, setEditReferenciaCaixa] = useState('');
  const [edit_quantidade, setEditQuantidade] = useState('');
  const [carrying, setCarrying] = useState(true);

  useEffect(()=> {
    async function loadConferred(){
      let data = {
        data: {
          status: pesquisa_status, 
          data: pesquisa_data,
          etiqueta_palete: pesquisa_etiqueta_palete,
          referencia_caixa: pesquisa_referencia_caixa,
          usuario_conferiu: pesquisa_usuario_conferiu,
          endereco: pesquisa_endereco,
          usuario_enderecou: pesquisa_usuario_enderecou,
          numero_documento: pesquisa_numero_documento,
          cliente: pesquisa_cliente,
          produto: pesquisa_produto,
          descricao_produto: pesquisa_descricao_produto,
          page: page,
          qtdePage: qtdePage,
        }
      };

      api.post("/api/conferred/search", data)
      .then((response) => {
          setList(response.data.dados);
          setTotal(response.data.qtde);
          setListAll(response.data);
          
          setLastPage(response.data.qtde, qtdePage);
          setCarrying(false);
        }
      ).catch((error) => {
        setCarrying(false);
        showMessageError(error.response.data);
      });
    }

    getData();
    loadConferred();

    return () => {

    }
  }, []);

  function setLastPage(aux_qtde, aux_qtdePage) {
    let lastPageIndex = parseInt(aux_qtde / aux_qtdePage);

    if ((aux_qtde % aux_qtdePage) > 0) {
      setLimitPage(lastPageIndex + 1);
    } else {
      setLimitPage(lastPageIndex);
    }
  }

  function pesquisar () {
    setCarrying(true);
    setPage(1);
    setQtdePage(qtdePage);

    let data = {
      data: {
        status: pesquisa_status, 
        data: pesquisa_data,
        etiqueta_palete: pesquisa_etiqueta_palete,
        referencia_caixa: pesquisa_referencia_caixa,
        usuario_conferiu: pesquisa_usuario_conferiu,
        endereco: pesquisa_endereco,
        usuario_enderecou: pesquisa_usuario_enderecou,
        numero_documento: pesquisa_numero_documento,
        cliente: pesquisa_cliente,
        produto: pesquisa_produto,
        descricao_produto: pesquisa_descricao_produto,
        page: page,
        qtdePage: qtdePage,
      }
    };

    api.post("/api/conferred/search", data)
    .then((response) => {
        setList(response.data.dados);
        setTotal(response.data.qtde);
        setLastPage(response.data.qtde, qtdePage);
        setListAll(response.data);
        setCarrying(false);
      }
    ).catch((error) => {
      showMessageError(error.response.data);
      setCarrying(false);
    });
  }

  function nextPage () {
    if (limitPage != page) {
      setCarrying(true);
      
      let data = {
        data: {
          status: pesquisa_status, 
          data: pesquisa_data,
          etiqueta_palete: pesquisa_etiqueta_palete,
          referencia_caixa: pesquisa_referencia_caixa,
          usuario_conferiu: pesquisa_usuario_conferiu,
          endereco: pesquisa_endereco,
          usuario_enderecou: pesquisa_usuario_enderecou,
          numero_documento: pesquisa_numero_documento,
          cliente: pesquisa_cliente,
          produto: pesquisa_produto,
          descricao_produto: pesquisa_descricao_produto,
          page: page+1,
          qtdePage: qtdePage,
        }
      };
      
      api.post("/api/conferred/search", data)
      .then((response) => {
        setList(response.data.dados);
        setTotal(response.data.qtde);
        setListAll(response.data);
        setCarrying(false);
        
        setPage(page+1);
        setQtdePage(qtdePage);
      }
      ).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
    }
  }

  function lastPage () {
    if (limitPage != page) {
      setCarrying(true);

      let data = {
        data: {
          status: pesquisa_status, 
          data: pesquisa_data,
          etiqueta_palete: pesquisa_etiqueta_palete,
          referencia_caixa: pesquisa_referencia_caixa,
          usuario_conferiu: pesquisa_usuario_conferiu,
          endereco: pesquisa_endereco,
          usuario_enderecou: pesquisa_usuario_enderecou,
          numero_documento: pesquisa_numero_documento,
          cliente: pesquisa_cliente,
          produto: pesquisa_produto,
          descricao_produto: pesquisa_descricao_produto,
          page: limitPage,
          qtdePage: qtdePage,
        }
      };

      api.post("/api/conferred/search", data)
      .then((response) => {
          setList(response.data.dados);
          setTotal(response.data.qtde);
          setListAll(response.data);
          setCarrying(false);

          setPage(limitPage);
          setQtdePage(qtdePage);
        }
      ).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
    }
  }

  function firstPage () {
    if (page != 1) {
      setCarrying(true);

      let data = {
        data: {
          status: pesquisa_status, 
          data: pesquisa_data,
          etiqueta_palete: pesquisa_etiqueta_palete,
          referencia_caixa: pesquisa_referencia_caixa,
          usuario_conferiu: pesquisa_usuario_conferiu,
          endereco: pesquisa_endereco,
          usuario_enderecou: pesquisa_usuario_enderecou,
          numero_documento: pesquisa_numero_documento,
          cliente: pesquisa_cliente,
          produto: pesquisa_produto,
          descricao_produto: pesquisa_descricao_produto,
          page: 1,
          qtdePage: qtdePage,
        }
      };

      api.post("/api/conferred/search", data)
      .then((response) => {
          setList(response.data.dados);
          setTotal(response.data.qtde);
          setListAll(response.data);
          setCarrying(false);

          setPage(1);
          setQtdePage(qtdePage);
        }
      ).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
    }
  }

  function previewPage () {
    if (page != 1) {
      setCarrying(true);

      let data = {
        data: {
          status: pesquisa_status, 
          data: pesquisa_data,
          etiqueta_palete: pesquisa_etiqueta_palete,
          referencia_caixa: pesquisa_referencia_caixa,
          usuario_conferiu: pesquisa_usuario_conferiu,
          endereco: pesquisa_endereco,
          usuario_enderecou: pesquisa_usuario_enderecou,
          numero_documento: pesquisa_numero_documento,
          cliente: pesquisa_cliente,
          produto: pesquisa_produto,
          descricao_produto: pesquisa_descricao_produto,
          page: page-1,
          qtdePage: qtdePage,
        }
      };

      api
      .post("/api/conferred/search", data)
      .then((response) => {
          setList(response.data.dados);
          setTotal(response.data.qtde);
          setListAll(response.data);
          setCarrying(false);

          setPage(page-1);
          setQtdePage(qtdePage);
        }
      ).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
    }
  }

  function searchEndereco(e) {
    if (e.target.value.toLowerCase() != '') {
      api.get("/api/adresses/searchAdresses?term=" + e.target.value.toLowerCase())
      .then((response) => {
        setListSearchEndereco(response.data.adresses);
      })
      .catch((error) => {
        showMessageError(error.response.data);
      });

      setDescricaoEndereco(e.target.value);
    } else {
      setPesquisaEndereco('');
      setDescricaoEndereco('');
      setListSearchEndereco([]);
    }
  }

  function editConferencia(index, item) {
    setEditConference(index);

    setId(item.id);
    setEditData(item.data);
    setEditEtiquetaPalete(item.etiqueta_palete);
    setEditReferenciaCaixa(item.referencia_caixa);
    setEditQuantidade(item.quantidade);
  }

  function saveEditConferencia() {
    let data = {
      data: {
        id: edit_id,
        data: edit_data,
        etiquetaPalete: edit_etiqueta_palete,
        referenciaCaixa: edit_referencia_caixa,
        quantidade: edit_quantidade,
        operation: 'E'
      }
    };

    api.post("/api/conferred/editItem", data)
    .then((response) => {
        toast.success('Registro salvo!');
        setEditConference('vazio');
        setId('');
        setEditData('');
        setEditEtiquetaPalete('');
        setEditReferenciaCaixa('');
        setEditQuantidade('');
        pesquisar();
      }
    ).catch((error) => {
      showMessageError(error.response.data);
    });
  }

  function removeConference(index, item) {
    let data = {
      data: {
        id: item.id,
        operation: 'D'
      }
    };

    api.post("/api/conferred/editItem", data)
    .then((response) => {
        toast.success('Registro Removido!');
        setEditData('');
        setEditEtiquetaPalete('');
        setEditReferenciaCaixa('');
        setEditQuantidade('');
        pesquisar();
      }
    ).catch((error) => {
      showMessageError(error.response.data);
    });
  }

  async function selectEndereco(item) {
    setPesquisaEndereco(item.id);
    setDescricaoEndereco(item.nome);
    setListSearchEndereco([]);
  }

  function conferred () {
    setModalConferred(true);
  }

  function closeModal () {
    setModalConferred(false);
  }

  async function getData() {
    api.get("/api/conferred/getDataPage")
    .then((response) => {
      setListStatus(response.data.status_documentos);
      setListEnderecos(response.data.enderecos);

      setCarrying(false);
    }).catch((error) => {
      showMessageError(error.response.data);
    });
  }

  return(
    <div>
      <Header/>
      <Division/>
      <Lateral/>
      <ReactTooltip />
      
      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando..</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content">
        <Title name="Itens Conferidos">
          
        </Title>
        
        <div className="container">
          
          <div className="divGroup">
            <select className='selectQtdeItens' value={qtdePage} onChange={ (e) => {setQtdePage(e.target.value);}}>
              <option value="1000">Itens por página</option>
              <option value="10">10</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="500">500</option>
              <option value="1000">1000</option>
            </select>
            <button className="buttonInsert pullRight" onClick={pesquisar}>
              Pesquisar
            </button> 
          </div>
          <br/>
          <div className="divGroup">
            <table>
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">
                    <div className="formDiv">
                      <select value={pesquisa_status} onChange={ (e) => setPesquisaStatus(e.target.value) } >
                        <option value="">Status</option>
                        {listStatus.map((item, index) => (
                          <option key={index} value={item.chave}>{item.descricao}</option>
                        ))}
                      </select>
                    </div>
                  </th>
                  <th scope="col">
                    <div className="formDiv">
                      <input type="text" placeholder="Data" value={pesquisa_data} onChange={ (e) => setPesquisaData(e.target.value) } maxLength="30"/>
                    </div>
                  </th>
                  <th scope="col">
                    <div className="formDiv">
                      <input type="text" placeholder="Palete" value={pesquisa_etiqueta_palete} onChange={ (e) => setPesquisaEtiquetaPalete(e.target.value) } maxLength="30"/>
                    </div>
                  </th>
                  <th scope="col">
                    <div className="formDiv">
                      <input type="text" placeholder="Ref. Caixa" value={pesquisa_referencia_caixa} onChange={ (e) => setPesquisaReferenciaCaixa(e.target.value) } maxLength="30"/>
                    </div>
                  </th>
                  <th scope="col">
                    <div className="formDiv">
                      <input type="text" placeholder="Usuário Conferência" value={pesquisa_usuario_conferiu} onChange={ (e) => setPesquisaUsuarioConferiu(e.target.value) } maxLength="30"/>
                    </div>
                  </th>
                  <th scope="col">Qtde</th>
                  <th scope="col">
                    <div className="formDiv">
                      <input type="text" placeholder="Endereço" value={descricao_endereco} onChange={searchEndereco} maxLength="60"/>
                      <ul className="dropdown-menu" id="enderecoDatalist">
                        {listSearchEndereco.map((item, index) => (
                          <li key={index} onClick={() => selectEndereco(item)}>
                            <a>{item.nome}</a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </th>
                  <th scope="col">
                    <div className="formDiv">
                      <input type="text" placeholder="Usuário Endereçamento" value={pesquisa_usuario_enderecou} onChange={ (e) => setPesquisaUsuarioEnderecou(e.target.value) } maxLength="30"/>
                    </div>
                  </th>
                  <th scope="col">
                    <div className="formDiv">
                      <input type="text" placeholder="Número Documento" value={pesquisa_numero_documento} onChange={ (e) => setPesquisaNumeroDocumento(e.target.value) } maxLength="30"/> 
                    </div>
                  </th>
                  <th scope="col">
                    <div className="formDiv">
                      <input type="text" placeholder="Cliente" value={pesquisa_cliente} onChange={ (e) => setPesquisaCliente(e.target.value) } maxLength="60"/>
                    </div>
                  </th>
                  <th scope="col">Cod. Pro.</th>
                  <th scope="col">
                    <div className="formDiv">
                      <input type="text" placeholder="Produto" value={pesquisa_produto} onChange={ (e) => setPesquisaProduto(e.target.value) } maxLength="60"/>
                    </div>
                  </th>
                  <th scope="col">Opções</th>
                </tr>
              </thead>
              <tbody>
                {list.map((item, index)=>{
                  return(
                    <tr key={index}>
                      <td>{index+1}</td>
                      <td>{viewItem(listStatus, item.status)}</td>
                      <td>{index == editConference &&
                          <div className="formDiv">
                            <input type="text" value={edit_data} onChange={ (e) => setEditData(e.target.value) } maxLength="10"/>
                          </div>} {index != editConference && item.data}
                      </td>
                      <td>
                        {index == editConference && 
                          <div className="formDiv">
                            <input type="text" value={edit_etiqueta_palete} onChange={ (e) => setEditEtiquetaPalete(e.target.value) } maxLength="17"/>
                          </div>} {index != editConference && item.etiqueta_palete}
                      </td>
                      <td>
                        {index == editConference && 
                          <div className="formDiv">
                            <input type="text" value={edit_referencia_caixa} onChange={ (e) => setEditReferenciaCaixa(e.target.value) } maxLength="60"/>
                          </div>} {index != editConference && item.referencia_caixa}
                      </td>
                      <td>{item.usuario_conferiu}</td>
                      <td>
                        {index == editConference && 
                          <div className="formDiv">
                            <input type="text" value={edit_quantidade} onChange={ (e) => setEditQuantidade(e.target.value) } maxLength="60"/>
                          </div>} {index != editConference && item.quantidade}
                      </td>
                      <td>{item.endereco}</td>
                      <td>{item.usuario_enderecou}</td>
                      <td>{item.numero_documento}</td>
                      <td>{item.cliente}</td>
                      <td>{item.cod_produto}</td>
                      <td>{item.descricao_produto}</td>
                      <td data-label="Opções">
                        {['002', '003'].indexOf(item.status) > -1  && index != editConference &&
                          <div>
                            <Link className="action" onClick={() => editConferencia(index, item)}>
                              <FaPen color="#000" size={17} />
                            </Link>
                            <Link className="action" onClick={() => removeConference(index, item)}>
                              <FaTrash color="#000" size={17} />
                            </Link>
                          </div>
                        }
                        {index == editConference && 
                        <div>
                          <Link className="action" onClick={() => saveEditConferencia()}>
                            <FaSave color="#000" size={17} />
                          </Link>
                        </div>
                        }
                      </td>
                    </tr>
                  )
                })}
                {list.length == 0 && <tr>
                  <td colSpan={14}><label className='required'>Nenhum registro encontrado!</label></td>
                </tr>}
              </tbody>
            </table>
          </div>
        </div>
        <br/>
        <div className="divGroupPagination">
            <button data-tip="Primeira página" type="button" onClick={firstPage} className="buttonFirstPage"><FaArrowLeft color="#001675" size={17} /><FaArrowLeft  color="#001675" size={17} /></button>
            <button data-tip="Página anterior" type="button" onClick={previewPage} className="buttonPreviewPage"><FaArrowLeft color="#001675" size={17} /></button>
            <div className="divLabelPagination">
              <center><label className="labelPage">Exibindo página {page} de {limitPage}</label></center>
              <center><label className="labelPage">Exibindo {qtdePage} de {total} registros</label></center>
            </div>
            <button data-tip="Próxima página" type="button" onClick={nextPage} className="buttonNextPage"><FaArrowRight color="#001675" size={17} /></button>
            <button data-tip="Última página" type="button" onClick={lastPage} className="buttonLastPage"><FaArrowRight color="#001675" size={17} /><FaArrowRight  color="#001675" size={17} /></button>
        </div>
      </div>}

      <Modal  
        isOpen={modalConferred}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Conferred"
        ariaHideApp={false}
      >
        <div className="body-modal">
          <div className="formDiv">
            <div className="divGroup">
              
            </div>
          </div>
          <div className="formDiv">
            <button type="button" className="buttonSubmit" onClick={conferred}>Imprimir</button>
            <button type="button" className="buttonCancel" onClick={closeModal}>Fechar</button>
          </div>
        </div>
      </Modal>
    </div>
  )
}